export function obterListaCodigoCorDenatran() {
  return (
    [
      { label: '1 - Amarelo', value: 'AMARELO' },
      { label: '2 - Azul', value: 'AZUL' },
      { label: '3 - Bege', value: 'BEGE' },
      { label: '4 - Branca', value: 'BRANCA' },
      { label: '5 - Cinza', value: 'CINZA' },
      { label: '6 - Dourada', value: 'DOURADA' },
      { label: '7 - Grena', value: 'GRENA' },
      { label: '8 - Laranja', value: 'LARANJA' },
      { label: '9 - Marrom', value: 'MARROM' },
      { label: '10 - Prata', value: 'PRATA' },
      { label: '11 - Preta', value: 'PRETA' },
      { label: '12 - Rosa', value: 'ROSA' },
      { label: '13 - Roxa', value: 'ROXA' },
      { label: '14 - Verde', value: 'VERDE' },
      { label: '15 - Vermelha', value: 'VERMELHA' },
      { label: '16 - Fantasia', value: 'FANTASIA' },
    ]
  );
}
